module.exports = __webpack_public_path__ + "img/giftcard.0c4dc4d.jpg";